import * as React from "react";
import { classNames } from "src/common/classNames";

import * as styles from "./SortableList.module.less";

export type SortableItemDef = {
  key: string;
  content: React.ReactNode | (() => React.ReactNode);
};

export type PropsSortableList = {
  items: SortableItemDef[];
  containerClass?: string;
  itemClass?: string;
  onChange?: (result: string[]) => void;
};

export const SortableList: React.FC<PropsSortableList> = ({
  items,
  containerClass,
  itemClass,
  onChange,
}) => {
  const [itemsInner, setItemsInner] = React.useState<SortableItemDef[]>(items);
  const [draggedItemIndex, setDraggedItemIndex] = React.useState<number | null>(
    null,
  );

  React.useEffect(() => {
    setItemsInner(items);
  }, [items]);

  const onDragStart = (index: number) => () => {
    setDraggedItemIndex(index);
  };

  const onDragOver =
    (index: number) => (event: React.DragEvent<HTMLLIElement>) => {
      event.preventDefault();
      if (draggedItemIndex === null) return;

      const dragOverItemIndex = index;
      if (draggedItemIndex === dragOverItemIndex) {
        return;
      }

      const itemsCopy = [...itemsInner];
      const itemToMove = itemsCopy.splice(draggedItemIndex, 1)[0];
      if (itemToMove) {
        itemsCopy.splice(dragOverItemIndex, 0, itemToMove);
        setDraggedItemIndex(dragOverItemIndex);
        setItemsInner(itemsCopy);
      }
    };

  const onDragEnd = () => {
    setDraggedItemIndex(null);
    onChange?.(itemsInner.map(({ key }) => key));
  };

  return (
    <ul className={containerClass}>
      {itemsInner.map(({ key, content }, index) => (
        <li
          key={key}
          className={classNames([styles.item, itemClass])}
          draggable
          onDragStart={onDragStart(index)}
          onDragOver={onDragOver(index)}
          onDragEnd={onDragEnd}
        >
          {typeof content === "function" ? content() : content}
        </li>
      ))}
    </ul>
  );
};
